var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mc-table"
  }, [!_vm.noHeader ? _c('div', {
    staticClass: "mc-table-header flex-box justify-space-between"
  }, _vm._l(_vm.columns, function (col, index) {
    return _c('div', {
      key: index,
      staticClass: "mc-table-header-cell",
      style: _vm.computedWidth(col)
    }, [_vm._v(" " + _vm._s(col.label) + " "), _c('span', {
      staticClass: "secondary-text"
    }, [_vm._v(_vm._s(col.label_desc))])]);
  }), 0) : _vm._e(), _vm.data.length ? _c('div', {
    staticClass: "mc-table-body"
  }, _vm._l(_vm.data, function (row, rowIndex) {
    return _c('div', {
      key: rowIndex,
      staticClass: "mc-table-row flex-box justify-space-between align-items-center"
    }, _vm._l(_vm.columns, function (col, colIndex) {
      return _c('div', {
        key: colIndex,
        staticClass: "mc-table-cell",
        style: _vm.computedWidth(col)
      }, [_vm._t(col.prop, function () {
        return [_vm._v(" " + _vm._s(row[col.prop]) + " ")];
      }, {
        "row": row,
        "col": col,
        "$index": rowIndex
      })], 2);
    }), 0);
  }), 0) : _c('div', {
    staticClass: "mc-table-body"
  }, [_c('el-empty', {
    attrs: {
      "image-size": 200
    }
  })], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };